import axios from 'axios';
import * as yup from 'yup';
import { stickyNotesSchema } from '~/schemas/stickyNotesSchema';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: stickyNotesSchema
});
export async function getStickyNotesRequest({ patientId }) {
    const response = await axios.post('/api/getStickyNotes', {
        patient_id: patientId,
    });
    console.log(response);
    const { data } = await responseSchema.validate(response.data);
    return {
        stickyNotes: data
    };
}
